import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { registerSW } from 'virtual:pwa-register';
import { ApiFehler } from './api/client';
import { App } from './App';
import { Fehlergrenze } from './layout/Fehlergrenze';
import { AuthProvider } from './lib/auth';
import { ToastProvider } from './ui';
import './styles/tokens.css';
import './styles/basis.css';

const abfragen = new QueryClient({
  defaultOptions: {
    queries: {
      // 4xx nicht wiederholen (401, 403, 404 aendern sich durch Warten nicht), alles andere hoechstens zweimal
      retry: (anzahl, fehler) => !(fehler instanceof ApiFehler && fehler.status >= 400 && fehler.status < 500) && anzahl < 2,
      refetchOnWindowFocus: true,
      // Offline (Phase 6): trotzdem einmal fragen, der Service Worker antwortet dann aus dem Cache
      networkMode: 'offlineFirst',
    },
  },
});

registerSW({ immediate: true });

const wurzel = document.getElementById('root');
if (!wurzel) throw new Error('#root fehlt');

createRoot(wurzel).render(
  <StrictMode>
    <Fehlergrenze>
    <QueryClientProvider client={abfragen}>
      <AuthProvider>
        <BrowserRouter>
          <ToastProvider>
            <App />
          </ToastProvider>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
    </Fehlergrenze>
  </StrictMode>,
);
